import { MarketingSiteLink } from "@mivo/ui/MarketingSiteLink";

export default function NotFound() {
    return (
        <>
            <div className="min-h-[40vh] flex items-center justify-center p-10 text-muted-foreground/80 text-sm">
                <div className="text-center">
                    <h1 className="font-display text-2xl font-bold leading-tight tracking-tight text-foreground sm:text-3xl">404 - Página não encontrada</h1>
                    <p className="mt-2">A página que você procura não existe ou foi movida.</p>
                    <MarketingSiteLink className="mt-4 inline-block text-muted-foreground hover:text-primary">
                        Voltar ao site
                    </MarketingSiteLink>
                </div>
            </div>
        </>
    );
}